<form [formGroup]="formGroupInput()">
  <div class="card-body">
    <div class="col-auto my-2">
      <app-validated-input
        [inputFormControl]="formGroupInput().controls.name"
        inputFormControlName="name"
        label="general.name"
        [leaveSpaceForValidation]="true"
      />
    </div>

    <div class="col-auto my-2">
      <app-validated-input
        [inputFormControl]="formGroupInput().controls.taxNumber"
        inputFormControlName="taxNumber"
        label="general.taxNumber"
        [leaveSpaceForValidation]="true"
      />
    </div>
    @if (showFillDataButton()) {
      <div class="col-auto my-2 mb-4">
        <app-button
          [disabled]="disabled() || !matchedLegalPerson()"
          [label]="
            'registrationWizard.legalPersonForm.fillWithExistingData'
              | translate
          "
          (clicked)="fillWithExistingData()"
        ></app-button>
      </div>
    }

    <!--div class="col my-2">
      <app-validated-dropdown
        [inputFormControl]="formGroupInput().controls.ownershipStructure"
        inputFormControlName="ownershipStructure"
        label="general.ownershipStructure"
        [leaveSpaceForValidation]="true"
        [haveEmptyOption]="true"
      >
        <option
          *ngFor="let ownershipStructure of store.ownershipStructureEntities()"
          [value]="ownershipStructure.id"
        >
          {{ ownershipStructure.name }}
        </option>
      </app-validated-dropdown>
    </div-->

    <div class="card mb-4">
      <div class="card-header">
        {{ "general.headquarters" | translate }}
      </div>

      <div class="card-body">
        <div class="col my-2">
          <app-validated-dropdown
            [inputFormControl]="formGroupInput().controls.country"
            inputFormControlName="country"
            label="general.country"
            [leaveSpaceForValidation]="true"
            [haveEmptyOption]="true"
            [disabled]="disabled()"
            [loading]="!store.allLoaded()"
            [optionsStamp]="store.countriesEntities().length"
          >
            <option
              *ngFor="let country of store.countriesEntities()"
              [value]="country.code"
            >
              {{ country.localized | getLocalized }}
            </option>
          </app-validated-dropdown>
        </div>

        <div class="col my-2">
          <app-validated-input
            [inputFormControl]="
              formGroupInput().controls.address.controls.zipCode
            "
            inputFormControlName="address.zipCode"
            label="general.postalCode"
            [leaveSpaceForValidation]="true"
          />
        </div>

        <div class="col my-2">
          <app-validated-input
            [inputFormControl]="formGroupInput().controls.address.controls.city"
            inputFormControlName="address.city"
            label="general.city"
            [leaveSpaceForValidation]="true"
          />
        </div>

        <div class="row align-items-end">
          <div class="col-12 col-md-6">
            <app-validated-input
              [inputFormControl]="
                formGroupInput().controls.address.controls.publicSpace
              "
              inputFormControlName="address.publicSpace"
              label="general.publicSpace"
              [leaveSpaceForValidation]="true"
            />
          </div>

          <div class="col-6 col-md-2">
            <app-validated-dropdown
              [inputFormControl]="
                formGroupInput().controls.address.controls.publicSpaceType
              "
              inputFormControlName="address.publicSpaceType"
              label="general.publicSpaceType"
              [leaveSpaceForValidation]="true"
              [disabled]="disabled()"
              [loading]="!store.allLoaded()"
              [optionsStamp]="store.publicSpaceTypeEntities().length"
            >
              <option
                *ngFor="let type of store.publicSpaceTypeEntities()"
                [value]="type.name"
              >
                {{ "generic.publicSpaceType." + type.name | translate }}
              </option>
            </app-validated-dropdown>
          </div>

          <div class="col-6 col-md-2">
            <app-validated-input
              [inputFormControl]="
                formGroupInput().controls.address.controls.houseNumber
              "
              inputFormControlName="address.houseNumber"
              label="general.houseNumber"
              [leaveSpaceForValidation]="true"
            />
          </div>

          <div class="col-6 col-md-2">
            <app-validated-input
              [inputFormControl]="
                formGroupInput().controls.address.controls.doorOrFloor
              "
              inputFormControlName="address.doorOrFloor"
              label="general.doorOrFloor"
              [leaveSpaceForValidation]="true"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="col-auto my-2">
      <app-validated-input
        [inputFormControl]="formGroupInput().controls.email"
        inputFormControlName="email"
        label="general.email"
        [leaveSpaceForValidation]="true"
      />
    </div>

    <!--div class="col my-2">
      <app-validated-dropdown
        [inputFormControl]="formGroupInput().controls.companyTypeId"
        inputFormControlName="companyTypeId"
        label="general.companyTypeId"
        [leaveSpaceForValidation]="true"
        [haveEmptyOption]="true"
        [disabled]="!formGroupInput().controls.country.value"
      >
        <option *ngFor="let country of companyTypes()" [value]="country.code">
          {{ country.localized | getLocalized }}
        </option>
      </app-validated-dropdown>
    </div-->

    @if (showBankAccount()) {
      <div class="card">
        <div class="card-header">
          {{ "general.optionalData" | translate }}
        </div>
        <div class="card-body">
          <div class="col-auto my-2">
            <app-validated-input
              [inputFormControl]="formGroupInput().controls.bankAccountNumber"
              inputFormControlName="bankAccountNumber"
              label="general.optionalBankNumber"
              [leaveSpaceForValidation]="true"
            />
          </div>
        </div>
      </div>
    }
  </div>
</form>
